import { useState, useContext, useEffect, useCallback } from 'react';
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { 
    AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, 
    Form, FormGroupWithIcon, ScreenContainer 
} from 'src/style';
import { explain } from 'src/utils/view'
import ReactTooltip from 'react-tooltip'
import helpers from 'src/utils/helpers';
import { BsEyeSlash, BsEye } from 'react-icons/bs';
import { QoreStaffTypes } from 'src/model';
import { useTranslation } from 'react-i18next';


const BuildConfiguration = () => {
    const {API} = useContext(ApiContext)
    const {info: {qoreStaffType}} = useContext(AppInfoContext)
    
    const [input, setInput] = useState(
        {
        packageName:'', 
        versionNumber:'',
        versionCode:'',
        keystorePassword:'',
        keystoreKey:'',
        keystoreAlias:'',
        updatedAt:'',}
    )
    const {t} = useTranslation()

    const [defaultDate] = !!input?.updatedAt ? new Date(input?.updatedAt)?.toISOString().split('T') : ''
    const [showPassword, setShowPassword] = useState(false);
    const [userType, setUserType] = useState('')
    const [inputsDisabled, setInputsDisabled] = useState(false);

    useEffect(() => {
        ReactTooltip.rebuild();
    }, [])

    useEffect(() => {
        if (qoreStaffType) {
            setUserType(qoreStaffType)

            if (qoreStaffType != QoreStaffTypes.DEVELOPER) {
                setInputsDisabled(true)
            }
        }
    }, [qoreStaffType])

    const getBuildInfo = useCallback(async()=>{
        const response = await API.fetchAndroidBuildInfoByCodeOrDefault()
        if (response?.isSuccessful) {
            setInput({
                ...input,
                ...response?.data
            })
        }
    },[API, input])

    useEffect(() => {
        
       (async()=>{
        await getBuildInfo()
       })()

    }, [])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    const handleSaveDefaultBuildInfo = useCallback( async (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) => {
        e.preventDefault()

        const response = await API.saveDefaultAndroidBuildInfo({
            packageName: input.packageName,
            versionNumber: input.versionNumber,
            versionCode: input.versionCode,
            keystorePassword: input.keystorePassword,
            keystoreKey: input.keystoreKey,
            keystoreAlias: input.keystoreAlias
        })

        if(response?.isSuccessful){
            
        }
    
    },[API, input])

    return (
        <>
            <AppText textSize='2.3' color='#101828' fontWeight="700" bottomMargin='1'>{t('buildConfiguration.title')}</AppText>
        <ScreenContainer>
            <Form onSubmit={handleSaveDefaultBuildInfo}>
                <CustomContainer topMargin='2'>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.packageName.label')}</label>
                            <div className="input-with-icon">
                                <input 
                                    placeholder="-----" 
                                    name='packageName'
                                    value={input.packageName}
                                    onChange={handleInput}
                                    autoComplete='off'
                                    disabled={inputsDisabled}
                                    required
                                />
                                <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                    {explain(
                                        t('buildConfiguration.packageName.tooltip'), true, '0'
                                    )}
                                </CustomContainer>
                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.versionNumber.label')}</label>
                            <div className="input-with-icon">
                                <input 
                                    placeholder="" 
                                    name='versionNumber'
                                    value={input.versionNumber}
                                    onChange={handleInput}
                                    autoComplete='off'
                                    disabled={inputsDisabled}
                                    required
                                />
                                <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                    {explain(
                                        t('buildConfiguration.versionNumber.tooltip'), true, '0'
                                    )}
                                </CustomContainer>
                            </div>
                        </FormGroupWithIcon>
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.versionCode.label')}</label>
                            <div className="input-with-icon">
                                <input 
                                    placeholder="" 
                                    name='versionCode'
                                    value={input.versionCode}
                                    onChange={handleInput}
                                    autoComplete='off'
                                    disabled={inputsDisabled}
                                    required
                                />
                                <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                    {explain(
                                        t('buildConfiguration.versionCode.tooltip'), true, '0'
                                    )}
                                </CustomContainer>
                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                        <label>{t('buildConfiguration.keystorePassword.label')}</label>
                        <div className="input-with-icon">
                            <input 
                                placeholder="XXXXXXX" 
                                name='keystorePassword'
                                type={showPassword ? 'text' : 'password'}
                                value={input.keystorePassword}
                                onChange={handleInput}
                                autoComplete='off'
                                disabled={inputsDisabled}
                                required
                            />
                            { !showPassword ?
                                <AbsoluteContainer bottom='2' right='3'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                        onClick={() => setShowPassword(true)}
                                    >
                                        <BsEyeSlash fontSize='1.7rem' />
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='2' right='3'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                        onClick={() => setShowPassword(false)}
                                    >
                                        <BsEye fontSize='1.7rem' />
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                            <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                {explain(
                                    t('buildConfiguration.keystorePassword.tooltip'), true, '0'
                                )}
                            </CustomContainer>
                        </div>
                    </FormGroupWithIcon>                
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.keystoreKey.label')}</label>
                            <div className="input-with-icon">
                                <input 
                                    placeholder="" 
                                    name='keystoreKey'
                                    value={input.keystoreKey}
                                    onChange={handleInput}
                                    autoComplete='off'
                                    disabled={inputsDisabled}
                                    required
                                />
                                <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                    {explain(
                                        t('buildConfiguration.keystoreKey.tooltip'), true, '0'
                                    )}
                                </CustomContainer>
                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.keystoreAlias.label')}</label>
                            <div className="input-with-icon">
                                <input 
                                    placeholder="" 
                                    name='keystoreAlias'
                                    value={input.keystoreAlias}
                                    onChange={handleInput}
                                    autoComplete='off'
                                    disabled={inputsDisabled}
                                    required
                                />
                                <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                    {explain(
                                        t('buildConfiguration.keystoreAlias.tooltip'), true, '0'
                                    )}
                                </CustomContainer>
                            </div>
                        </FormGroupWithIcon>
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('buildConfiguration.updatedAt.label')}</label>
                                <div className="input-with-icon">
                                    <input 
                                    name='updatedAt'
                                    type='date'
                                    max={helpers.getInputValidDate()}
                                    value={defaultDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    disabled={inputsDisabled}
                                />
                                </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon />
                    </FlexRow>   
                </CustomContainer>
                { userType === QoreStaffTypes.DEVELOPER &&
                    <FlexRow justifyContent='flex-end' gap='2' bottomMargin='3.5'>
                        <Button
                            width='12' bgColor='#ffffff'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            color='#0D968F' hoverColor='#ffffff'
                            hoverBgColor='#0D968F'
                            borderColor='#0D968F'
                        >
                            {t('buildConfiguration.buttons.saveSettings')}
                        </Button>
                    </FlexRow>
                }
            </Form>
        </ScreenContainer>
        </>
    )
}

export default utility.routeData('build-configuration', 'Build Configuration', <BuildConfiguration/>)